import MobilePageLayout from "../../../layouts/MobilePageLayout";
import FindAssetForm from "./components/FindAssetForm";
import {ScreenProps} from "../../../../../utils/screen-props-helper";
import {AssetStackParamList} from "../AssetStack";
import {
  useLazyGetAssetQuery,
  useUpdateAssetMutation
} from "../../../../../store/services/api/asset-api";
import {useModal} from "../../../../../hooks/useModal";
import React, {useState} from "react";
import {useSetLoading} from "../../../../../hooks/useSetLoading";
import ConfirmModal from "../../../modals/ConfirmModal";
import SelectAssetModal from './components/SelectAssetModal';

export default function AssetReplaceQRScreen({route, navigation}: ScreenProps<AssetStackParamList, 'replaceQr'>) {
  const uniqueRef = route.params?.uniqueRef;
  const [getAsset, {isFetching: assetFetching}] = useLazyGetAssetQuery();
  const [updateAsset] = useUpdateAssetMutation();

  useSetLoading([assetFetching]);
  const [showAssetSelectModal, setShowAssetSelectModal] = useState(false);
  const [assetSearchParams, setAssetSearchParams] = useState<Record<string, string>>({});

  const {showModal, hideModal} = useModal();

  const handleOnAssetSearch = (params: any)=> {
    setShowAssetSelectModal(true);
    setAssetSearchParams(params);
  }

  const updateUniqueRef = async (assetId: string) => {
    const performUpdate = async () => {
      const assetResponse = await getAsset(assetId);

      if (assetResponse.isError) {
        alert("Error getting asset");
        return;
      }
      const updatedAsset = {
        ...assetResponse.data,
        uniqueReference: uniqueRef
      };

      try {
        await updateAsset(updatedAsset);
      } catch (e) {
        alert("Error updating asset");
      }

      navigation.navigate('asset', {uniqueRef});
    }

    showModal(
      <ConfirmModal
        onConfirm={() => {
          hideModal();
          performUpdate();
        }}
        onCancel={hideModal}
      />
    )
  }

  return (
    <MobilePageLayout>
      <FindAssetForm onSubmit={handleOnAssetSearch} />
      <SelectAssetModal
        onOk={(assetId: string) => {
          setShowAssetSelectModal(false);
          updateUniqueRef(assetId);
        }}
        onCancel={() => {
          setShowAssetSelectModal(false);
        }}
        cancelText='Close'
        open={showAssetSelectModal}
        query={assetSearchParams}
      />
    </MobilePageLayout>
  )
}
